import React from "react";
import * as Styled from "./Card.styles";
import { CardProps } from "./Card.types";

export const Card = (props: CardProps) => {
  const { variant = "Dark" } = props;
  return <Styled.Card {...props} variant={variant} />;
};
